import { useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import type { UseResourceReturn } from '../common/project-sidebar-navigation-resource/types';

export const useInitFetchResource = <TResource,>(
	resource: UseResourceReturn<TResource>,
	skip = false,
): UseResourceReturn<TResource> => {
	const { data, loading, error, refresh, ...rest } = resource;

	useEffect(() => {
		// skip init fetch resource when ff is off
		if (!ff('fission-nav4-fetch-from-router_ma0x8') || skip) {
			return;
		}
		if (!data && !loading && !error && refresh) {
			refresh();
		}
	}, [data, loading, error, refresh, skip]);

	return {
		data,
		loading,
		error,
		refresh,
		...rest,
	};
};
